export default "__VITE_ASSET__scuMrmaT__"